import { render, staticRenderFns } from "./dwelling-queue-application.vue?vue&type=template&id=24127605"
import script from "./dwelling-queue-application.vue?vue&type=script&lang=js"
export * from "./dwelling-queue-application.vue?vue&type=script&lang=js"
import style0 from "./dwelling-queue-application.vue?vue&type=style&index=0&id=24127605&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports